import {Table, Tooltip} from "antd";
import React from "react";
import sorters from "../../util/sorters";
import moment from "moment/moment";
import {PREFERRED_DATE_FORMAT, PREFERRED_DATETIME_FORMAT} from "../../util/time";

const AdjustmentsTable = ({
                            records,
                            reference,
                            loading,
                            hideColumns,
                            pagination,
                            all,
                            scroll
                          }) => {

  const columns = [
    {
      title: 'ID',
      width: 80,
      align: 'right',
      sorter: (a, b) => sorters.number(a.ID, b.ID),
      dataIndex: 'ID',
      hidden: hideColumns
    },
    {
      title: 'Created',
      width: 165,
      sorter: (a, b) => sorters.date(a.CreatedAt, b.CreatedAt),
      render: r => moment(r.CreatedAt).format(PREFERRED_DATETIME_FORMAT),
      hidden: hideColumns
    }, {
      title: 'Updated',
      width: 165,
      sorter: (a, b) => sorters.date(a.UpdatedAt, b.UpdatedAt),
      render: r => moment(r.UpdatedAt).format(PREFERRED_DATETIME_FORMAT),
      hidden: hideColumns
    }, {
      title: 'Category',
      sorter: (a, b) => sorters.string(a.categoryCode, b.categoryCode),
      render: r => (
        <Tooltip title={reference.types[r.projectorExpenseTypeId]} placement="bottom"
                 overlayInnerStyle={{width: '450px'}}>
          {r.categoryCode}
        </Tooltip>
      )
    }, {
      title: 'Employee',
      sorter: (a, b) => sorters.string(reference.workers[a.d365workerId], reference.workers[b.d365workerId]),
      render: r => (
        <Tooltip title={`${r.workerId}: ${r.employee}`} placement="bottom" overlayInnerStyle={{width: '450px'}}>
          {reference.workers[r.d365workerId]}
        </Tooltip>
      )
    }, {
      title: 'Project Code',
      sorter: (a, b) => sorters.string(a.projectCode, b.projectCode),
      dataIndex: 'projectCode'
    }, {
      title: 'Amount',
      align: 'right',
      sorter: (a, b) => sorters.number(a.projectorAmount, b.projectorAmount),
      dataIndex: 'projectorAmount'
    }, {
      title: 'Date',
      sorter: (a, b) => sorters.date(a.softCostDate, b.softCostDate),
      render: r => moment(r.softCostDate).format(PREFERRED_DATE_FORMAT)
    }, {
      title: 'Transaction',
      sorter: (a, b) => sorters.string(a.transactionId, b.transactionId),
      dataIndex: 'transactionId'
    }, {
      title: 'Status',
      sorter: (a, b) => sorters.string(a.status, b.status),
      render: r => (
        r.skippedReason === null ? r.status : (
          <Tooltip title={r.skippedReason} placement="bottomLeft" overlayInnerStyle={{width: '300px'}}>
            {r.status}
          </Tooltip>
        )
      )
    }
  ].filter(item => !item.hidden);
  if (all) {
    columns.push({
      title: 'Upload ID',
      sorter: (a, b) => sorters.number(a.uploadId, b.uploadId),
      dataIndex: 'uploadId',
      align: 'right'
    })
  }

  return (
    <>
      <Table
        rowKey="ID"
        dataSource={records}
        columns={columns}
        pagination={pagination}
        size="small"
        loading={loading}
        scroll={scroll}
      />
    </>
  );
}

export {AdjustmentsTable};